import React from "react";
import styles from "./MediaLoader.scss";
import { Modal } from "../modal/Modal";
import classNames from "classnames";
import PropTypes from "prop-types";

export function MediaLoader({ inlineLoading, className }) {
  return (
    <></>
    // <Modal className={classNames(inlineLoading ? styles.inlineScreen : styles.fullscreen, className)}>
    //   <div className="loader-wrapper">
    //     <div className="layer"></div>
    //     <div className="loader">
    //       <div className="loader-center" />
    //     </div>
    //   </div>
    // </Modal>
  );
}

MediaLoader.propTypes = {
  inlineLoading: PropTypes.bool,
  className: PropTypes.string
};
